<template>
<div class="contentBox liveEditPage">
    <div class="pageTitle">
        <!--<h1>直播编辑</h1>-->
        <el-steps :active="0" simple finish-status="wait" style="padding-left: 0;width: 100%">
            <el-step title="编辑" icon="el-icon-edit"></el-step>
            <el-step v-if="channelId>0" title="发起直播" icon="el-icon-video-play" @click.native="jumpNavPage('/live/launch')"></el-step>
            <el-step v-if="channelId>0" title="分享" icon="el-icon-share" @click.native="jumpNavPage('/live/share')"></el-step>
            <el-step v-if="channelId>0" title="监控统计" icon="el-icon-data-analysis" @click.native="jumpNavPage('/live/statistics')"></el-step>
            <el-step v-if="channelId>0" title="录播" icon="el-icon-video-camera" @click.native="jumpNavPage('/live/history')"></el-step>
        </el-steps>
    </div>
    <div class="certificationInfoBox">
        <div class="infoItem">
            <span class="title">标题</span>
            <el-input class="w600 titleInput" placeholder="请输入文字" v-model.trim="channel.title" ref="channelTitle"/>
        </div>
        <div class="infoItem">
            <span class="title">海报</span>
            <div class="uploadImgBox">
                <el-form :model="form">
                    <el-form-item>
                        <el-upload ref="upload" 
                            action="#" 
                            accept="image/png,image/gif,image/jpg,image/jpeg" 
                            list-type="picture-card"
                            :file-list="posterList"
                            :auto-upload="false" 
                            :on-exceed="handleExceed" 
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            :on-change="handleChangePic"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <span class="uploadTips">选择海报</span>
                            <!--<div slot="tip" class="el-upload__tip" style="margin-bottom: 8px">只能上传jpg/png文件，且不超过4M</div>-->
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="infoItem">
            <span class="title">类型</span>
            <div class="userType">
                <el-select v-model="channel.typeId" placeholder="请选择" class="selectType">
                    <el-option v-for="item in liveTypes" :key="item.typeId" :label="item.typeName" :value="item.typeId"></el-option>
                </el-select>
            </div>
        </div>
        <div class="infoItem">
            <span class="title">简介</span>
            <froala :tag="'textarea'" :config="config" v-model="channel.intro"></froala>
        </div>
        <div class="infoItem">
            <span class="title">VR直播</span>
            <el-switch v-model="channel.isVR" :active-value="1" :inactive-value="0" active-color="#306FF6" inactive-color="#C1C5C5" @change="vrSwitchChanged">
            </el-switch>
            <span class="switchTips">VR直播频道会专用直播设备，直播时启用专用播放器</span>
        </div>
        <div class="infoItem">
            <span class="title">云录制</span>
            <el-switch v-model="channel.cloudSave" :active-value="1" :inactive-value="0" active-color="#306FF6" inactive-color="#C1C5C5">
            </el-switch>
            <span class="switchTips">直播自动录制在云端，占用存储容量。</span><span style="color: #303133; font-weight: bold">注：保存频道后，需重新启动直播，如使用第三方推流器，需填写新的推流地址后才可生效。</span>
        </div>
        <div class="infoItem">
            <span class="title">低延时</span>
            <el-switch v-model="channel.rtsEnabled" :active-value="1" :inactive-value="0" active-color="#306FF6" inactive-color="#C1C5C5" :disabled="channel.rtsUsable">
            </el-switch>
            <span class="switchTips">低延时直播可大大缩短直播延时，直播时长按双倍扣除。</span>
        </div>
    </div>
    <div class="advancedLive" :style="{ height: advancedIsShow ? '199px' : '40px' }">
        <div class="title">
            <span>高级</span>
            <div id="roundArrow" :class="[advancedIsShow ? 'down' : 'up']" @click="toggleAdvanced"></div>
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">公开</span>
                <el-switch v-model="channel.isOpen" :active-value="1" :inactive-value="0" active-color="#306FF6" inactive-color="#C1C5C5"></el-switch>
                <span v-if="channel.isOpen === 0" class="passwordTips">观看密码：</span>
                <el-input v-if="channel.isOpen === 0" v-model.trim="channel.accessKey" class="password" ref="channelKey"></el-input>
            </div>
            <div class="infoItem">
                <span class="label">互动</span>
                <el-switch v-model="channel.interact" :active-value="1" :inactive-value="0" active-color="#306FF6" inactive-color="#C1C5C5">
                </el-switch>
            </div>
            <div class="infoItem">
                <span class="label">隐私</span>
                <template>
                    <el-radio-group v-model="channel.visible">
                        <el-radio :label="1">Quicklive列出</el-radio>
                        <el-radio :label="2">Quicklive隐藏(不列出，分享链接可访问)</el-radio>
                        <el-radio :label="0">仅提供流服务</el-radio>
                    </el-radio-group>
                </template>
            </div>
        </div>
    </div>
    <div class="actionBtnBox">
        <el-button type="primary" class="submitBtn" @click="saveChannel" :loading="savingChannel">保存</el-button>
        <!--<button class="submitBtn" @click="saveChannel">提交</button>-->
        <button class="resetBtn" @click="back">返回</button>
    </div>
</div>
</template>
<script>
    import common from '../../common.vue';
    import OSS from 'ali-oss';
    import 'froala-editor/js/languages/zh_cn.js';
    import 'froala-editor/js/plugins/image.min.js';
    import 'froala-editor/js/plugins/align.min.js';
    import 'froala-editor/js/plugins/table.min.js';
    import 'froala-editor/js/plugins/font_size.min';

    const SAVE_RESULT_MAPPER = {
        '0':'',
        '-1': '登录已过期',
        '-2': '保存失败,流量或时长不足',
        '-3': '保存失败，空间用尽，无法开启云录制'};

    export default {
        name: "LiveEdit",
        data() {
            return {
                channelId: -1,
                advancedIsShow: true,

                dialogImageUrl: '',
                dialogVisible: false,
                form: {},

                // 直播分类
                liveTypes: [],
                // 频道
                channel:{isVR: 0, cloudSave: 1, rtsEnabled: 0, isOpen: 1, visible: 1, interact: 1, accessKey:""},
                // 内容是否更改
                channelChanged : false,
                // 成功上传的海报列表
                posterList: [],
                // 选择的海报文件
                posterFile: null,
                // oss上传配置
                ossConfig: {},
                // 如果上传新海报，海报的在oss上的路径
                posterPath: null,
                // 是否在保存
                savingChannel: false,

                // html编辑器
                editor: null,
                config: {
                    language: 'zh_cn',
                    imageUploadParam:"file",
                    imageMaxSize: 1024 * 1024 * 10,  //限制10MB大小
                    imageUploadURL: common._BASE_ + 'content/uploadImage',
                    imageUploadParams: {fileName: ""},
                    imageDefaultWidth: 414,
                    events: {
                       initialized:function(e, editor){
                           this.editor = editor;
                            console.log('froala editor initialized')
                       },
                       focus: function () {
                            console.log('froala editor focused');
                        }
                    }
                }
            };
        },
        watch: {
            'channel': {
                handler () {
                    // form 对象内部的值变化时，设置 formChange
                    this.channelChanged = true;
                },
                deep: true
            }
        },
        methods: {
            toggleAdvanced() {
                this.advancedIsShow = !this.advancedIsShow;
            },

            back(){
                let _this = this;
                if(_this.channelChanged){
                    _this.$confirm("确定离开编辑页面吗？未保存内容将丢失。","确认",{
                        iconClass: "el-icon-question",
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        showClose: true,
                        type: "warning",
                    }).then(function(){
                        _this.channelChanged= false;
                        _this.$router.go(-1);
                    });
                }else{
                    this.$router.go(-1);
                }
            },

            // 新上传的图片替换老的图片
            handleChangePic(file, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                this.posterFile = file.raw;
                this.channelChanged = true;
            },
            // 文件超出个数限制时的钩子
            handleExceed() {
                alert('只可以上传一个文件');
            },
            // 文件列表移除文件时的钩子
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            // 点击文件列表中已上传的文件时的钩子
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            // 上传图片到服务器
            uploadFile() {
                this.$refs.upload.submit()
            },
            // 获取直播类型
            getTypes(cb) {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'lt/getAll').then(function (res) {
                    let r = res.data;
                    _this.liveTypes = r.data || [];
                    
                    if(cb){ cb();}
                });
            },
            // 获取频道信息
            getChannel(cid){
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/loadChannel', this.$qs.stringify({cId: cid})).then(function (res) {
                    let r = res.data;
                    if(parseInt(r.code) === 0 && r.data) {
                        _this.channel = r.data;
                        _this.channel.rtsUsable = (parseInt(_this.channel.isVR) > 0);
                        _this.posterList.push({url: _this.channel.poster});
                        setTimeout(function(){
                            _this.channelChanged = false;
                        }, 20);
                    }else{
                        _this.$message({
                            message: '加载频道失败',
                            type: 'error'
                        });
                    }
                });
            },
            vrSwitchChanged(v){
                if(parseInt(v) > 0){
                    this.channel.rtsEnabled = 0;
                }
                this.channel.rtsUsable = (parseInt(v) > 0);
            },
            // 检查频道信息是否合法
            checkInput(){
                let _this = this, c = this.channel;
                // 标题
                if(!c.title || c.title === ''){
                    this.$message({
                        message: '请输入频道标题',
                        type: 'warning',
                        onClose: function(){
                            _this.$refs.channelTitle.focus();
                        }
                    });
                    return false;
                }
                if(!c.typeId || parseInt(c.typeId) < 0){
                    this.$message({
                        message: '请选择类型',
                        type: 'warning'
                    });
                    return false;
                }
                if((!c.channelId || c.channelId < 0) && !this.posterFile){
                    this.$message({
                        message: '请为直播选择海报',
                        type: 'warning'
                    });
                    return false;
                }
                // 非开放频道需要输入密码
                console.info('isOpen:' + c.isOpen + " key:" + c.accessKey);
                if(c.isOpen === 0 && (!c.accessKey || c.accessKey === '' )){
                    this.$message({
                        message: '不公开频道，必须设定密码',
                        type: 'warning',
                        onClose: function(){
                            _this.$refs.channelKey.focus();
                        }
                    });
                    return false;
                }
                // 检查余额是否可以创建频道
                let b = localStorage.getItem('balance');
                if(b){
                    let balance = JSON.parse(b);
                    if (balance.totalSpace > 0 &&
                        balance.space >= balance.totalSpace && c.cloudSave > 0){
                        this.$message({
                            message: '空间用尽，无法开启云录制',
                            type: 'warning'
                        });
                        return false;
                    }
                }

                return true;
            },
            /**
             * 上传文件
             * @param file
             * @param callback
             */
            ossUploadFile(file, callback){
                if(!file){ return null; }

                let _this = this,
                    ossClient = new OSS(this.ossConfig),
                    fileName = common.guid() + "." + common.fileExt(file.name),
                    ossKey = common.assertPath(this.ossConfig.folder) + fileName;
                ossClient.put(ossKey, file).then(function(r){
                    console.info(r);
                    callback && callback(ossKey);
                }).catch(function (err) {
                    console.error('error: %j', err);
                    _this.$notify({
                        title: '错误',
                        message: err,
                        type: 'error'
                    });
                    return null;
                });
            },
            // 保存频道信息
            saveChannel(){
                let _this = this;
                if(_this.checkInput()){
                    // 如果有海报需要上传
                    _this.savingChannel = true;
                    if(_this.posterFile){
                        _this.ossUploadFile(_this.posterFile,function (ossKey) {
                            _this.posterPath = ossKey;
                            _this.doSave();
                        });
                    }else{
                        _this.doSave();
                    }
                }
            },
            doSave() {
                let _this = this;
                if (_this.posterPath && _this.posterPath !== '') {
                    _this.channel.poster = _this.posterPath;
                }
                _this.$axios.post(common._BASE_ + 'channel/saveChannel', this.$qs.stringify(_this.channel)).then(function (res) {
                    let r = res.data;
                    switch (parseInt(r.code)) {
                        case 0:  _this.channelChanged = false; _this.$router.push('/live/list'); return;
                        case -1: _this.channelChanged = false; _this.$router.push('/login'); return;
                        case -2:
                        case -3:
                            _this.$message({message: SAVE_RESULT_MAPPER['' + res.code], type: 'error'});
                            return;
                    }
                    _this.savingChannel = false;
                });
            },

            getCredential(callback){
                let _this = this;

                _this.$axios.post(common.OSS_CREDENTIAL_URL).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        callback && callback(r);
                    }
                    r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 根据服务器上返回的授权构建oss配置
             */
            buildConfig(credential){
                let _this = this;
                _this.ossConfig = Object.assign({
                    refreshSTSToken: async () => {
                        _this.getCredential(function(r){
                            return r;
                        });
                    }
                }, credential);
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path,
                    params: { cid: this.channelId },
                    query: {cid: this.channelId}
                });
            }
        },
        mounted(){
            let _this = this;
            this.getTypes(function () {
                let cid = _this.$route.params.cid || _this.$route.query.cid;
                if(cid && parseInt(cid) > 0){
                    _this.channelId = cid;
                    _this.getChannel(cid);
                }
            });
            _this.getCredential(function (c) {
                _this.buildConfig(c);
            });
        },
        beforeRouteLeave: function(to, from , next) {
            if(this.channelChanged){
                this.$confirm("确定离开编辑页面吗？未保存内容将丢失。","确认",{
                    iconClass: "el-icon-question",
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    showClose: true,
                    type: "warning",
                }).then(function(){
                    next();
                });
            }else{
                next();
            }
        }

    };
</script>
<style lang="less">
    .liveEditPage {
        /*.el-upload--picture-card{
            width: 264px;
            height: 148px;
        }
        .el-upload{
            width: 264px;
            height: 148px;
            line-height: 148px;
        }
        .el-upload-list--picture-card .el-upload-list__item{
            width: 264px;
            height: 148px;
            line-height: 148px;
        }
        .el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 264px;
            height: 148px;
            line-height: 148px;
        }*/
        .certificationInfoBox {
            width: 1210px;
            background: #ffffff;
            border: 1px solid #e8e8e8;
            padding: 30px 0 10px 32px;
            font-size: 14px;

            .infoItem {
                display: flex;
                margin-bottom: 22px;
                /*line-height: 40px;*/
                align-items: center;
            }

            .downloadItem {
                margin-bottom: 9px;
            }

            .w600 {
                width: 600px;
            }

            .title {
                width: 74px;
            }

            .titleInput .el-input__inner::-webkit-input-placeholder {
                font-size: 14px;
                color: #c0c5c5;
            }

            .userType {
                .el-select .el-input__inner::-webkit-input-placeholder {
                    color: #33363f;
                }

                .el-select .el-input__inner::-moz-input-placeholder {
                    color: #33363f;
                }

                .el-select .el-input__inner::-ms-input-placeholder {
                    color: #33363f;
                }
            }

            .errorHint {
                height: 40px;
                font-size: 14px;
                line-height: 40px;
                color: #dc5986;
                margin-left: 16px;
            }

            .uploadImgBox {
                width: 800px;
                height: 160px;
                position: relative;

                .el-upload--picture-card {
                    width: 240px;
                    height: 148px;
                    background: #f5f6f7;
                    border: 1px solid #c1c5c5;
                    border-radius: 4px;
                    position: relative;
                    cursor: pointer;

                    .uploadTips {
                        width: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 10;
                        color: #a2a9ab;
                        text-align: center;
                        padding-top: 26px;
                    }
                }

                .el-upload--picture-card:hover {
                    border-color: #409eff;

                }

                .el-upload-list--picture-card {
                    .el-upload-list__item-thumbnail {
                        width: 100%;
                        height: auto;
                    }
                }
            }

            .switchTips {
                margin-left: 10px;
            }
        }

        .advancedLive {
            width: 1210px;
            height: 199px;
            background: #ffffff;
            border: 1px solid #e8e8e8;
            margin: 15px 0;
            overflow: hidden;

            .title {
                height: 44px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #e9e9e9;
                padding: 0 21px;
                font-size: 16px;
                font-weight: bold;
                color: #221816;

                span::before {
                    content: "";
                    display: inline-block;
                    width: 4px;
                    height: 12px;
                    background: #306ff6;
                    border-radius: 3px;
                    margin-right: 6px;
                }
            }

            .infoItem {
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-bottom: 17px;
            }

            .downloadItem {
                margin-bottom: 9px;
            }

            .w600 {
                width: 600px;
            }

            .label {
                width: 74px;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #221816;
            }

            .advancedInfo {
                padding: 16px 32px;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #221816;
            }

            .passwordTips {
                margin-left: 21px;
                margin-right: 10px;
            }

            .password {
                width: 151px;
            }

            .confirmBtn {
                width: 61px;
                height: 40px;
                background: #076eff;
                border-radius: 4px;
                color: #ffffff;
                margin-left: 5px;
            }

            .confirmBtn:hover {
                background: #4aa3f8;
            }
        }

        #roundArrow {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: url("../../assets/round-arrow-gary.svg") no-repeat center center;
            background-size: 100% 100%;
            transition: all 0.2s;
            -webkit-transition: all 0.2s;
            cursor: pointer;
        }

        #roundArrow:hover {
            background: url("../../assets/round-arrow-blue.svg") no-repeat center center;
            background-size: 100% 100%;
        }

        #roundArrow.up {
            transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
        }

        .actionBtnBox {
            button {
                width: 110px;
                height: 40px;
                border-radius: 4px;
                font-size: 14px;
            }

            .resetBtn {
                background: #ffffff;
                border: 1px solid #c1c5c5;
            }

            .resetBtn:hover {
                background: #306ff6;
                color: #fff;
                border: none;
            }

            .submitBtn {
                background: #076eff;
                color: #fff;
                margin-right: 22px;
            }

            .submitBtn:hover {
                background: #4aa3f8;
            }
        }

    }

    .introText {
        height: 120px;
    }

    .el-textarea.introText .el-textarea__inner {
        padding: 10px;
        font-size: 14px;
    }

    .el-textarea.introText .el-textarea__inner::-webkit-scrollbar {
        width: 4px;
        border-radius: 4px;
        background: #f5f6f7;
    }

    .el-textarea.introText .el-textarea__inner::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #076eff;
        border-radius: 4px;
    }

    .el-textarea.introText .el-textarea__inner::-webkit-input-placeholder {
        color: #c0c5c5;
    }
</style>
